import type { TreatmentPlanItems } from '@common/TreatmentPlan/types';
import { DrugHistoryList } from '@store/models/SystemFields/Drug/DrugHsitoryList';
import type { DrugList } from '@store/models/SystemFields/Drug/DrugList';
import { DrugData } from 'chaika-frontend-types/frontend-cms';
import { isDefined } from '@utils/isDefined';

interface FilterDrugsParams {
    entryId: string;
    isOnPrint: boolean;
    fromSignedEntry: boolean;
    actualOn: string;
    drugHistoryList: DrugHistoryList;
}

export function getFilteredDrugsData(
    drugPrams: Pick<TreatmentPlanItems, 'drugs' | 'drugList'>,
    params: FilterDrugsParams,
): DrugData[] {
    const { drugs, drugList } = getFilteredDrugs(drugPrams, params);

    return drugs.map(id => drugList.getExisting(id));
}

export function getFilteredDrugs(
    { drugList, drugs: drugIds }: Pick<TreatmentPlanItems, 'drugs' | 'drugList'>,
    { entryId, fromSignedEntry, actualOn, drugHistoryList, isOnPrint }: FilterDrugsParams,
): Pick<TreatmentPlanItems, 'drugs' | 'drugList'> {
    let drugs = drugIds.filter(id => {
        const drug = drugList.get(id);
        return (
            drugList.has(id) &&
            (isOnPrint
                ? drug?.isActualOnDate(actualOn) || drug?.isBelongToEntry(entryId)
                : !drugList.getExisting(id).isCancelled)
        );
    });

    if (fromSignedEntry) {
        drugs = drugs
            .map(item => drugHistoryList.get(item))
            .filter(isDefined)
            .filter(item => item.metaData?.some(metadata => metadata.entryId === entryId))
            .map(item => item.id);
    }

    return { drugs, drugList };
}

export function filterDrugIdsByMedicalCase(drugIds: string[], drugList: DrugList, medicalCaseId: string): string[] {
    return drugIds.filter(id => drugList.has(id) && drugList.getExisting(id).medicalCaseIds.includes(medicalCaseId));
}
